import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import ProcessFollow from "../../components/ProcessFollow.js";
import { Helmet } from "react-helmet-async";

const FrontendDev = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Boost your online presence with India’s Best Front End Development Company. We craft responsive, high-performing UI/UX designs that drive engagement and leads."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Front End Development Company in India | UI & UX Experts | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/frontend-dev"
        />
        <meta
          property="og:description"
          content="Boost your online presence with India’s Best Front End Development Company. We craft responsive, high-performing UI/UX designs that drive engagement and leads."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Front End Development Company in India | UI & UX Experts | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Boost your online presence with India’s Best Front End Development Company. We craft responsive, high-performing UI/UX designs that drive engagement and leads."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/frontend-dev"
        />
        <title>
          Front End Development Company in India | UI & UX Experts | Ayanshtech
          Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center mb-6 py-6">
        <div className=" py-5 px-5 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 text-center lg:text-left p-6">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Leading Front End Development Services in India
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                We specialize in designing intuitive user interfaces with
                seamless navigation, fast loading speed, and optimized
                performance—ensuring your brand stands out in the competitive
                digital space. Whether you’re planning to revamp your existing
                website or build a new one from scratch, our team delivers a
                smooth, engaging experience across all devices and platforms.
                <br />
                At Ayanshtech, our front-end development expertise spans HTML5,
                CSS3, JavaScript, and modern frameworks like React, Angular, and
                Vue.js. By combining creativity with cutting-edge technology, we
                ensure your website not only looks exceptional but performs
                flawlessly.
                <br />
                With a focus on clean coding practices, UI/UX excellence, and
                future-ready design, we help your business stay ahead of the
                curve—empowering you to deliver an outstanding experience to
                every visitor while boosting conversions and growth.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\webAppDev\frontend1.avif"
                alt="Front End Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 p-6">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Frontend Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Unlock the potential of your web presence with frontend solutions
            that are both powerful and user-friendly.
          </p>
        </div>

        <div className="  ml-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Responsive Web Design</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom UI/UX Design</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Performance Optimization</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cross-Browser Compatibility</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Scalable Solutions</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">SEO Optimized Websites</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                JavaScript Frameworks (React, Vue.js, Angular)
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Mobile-First Design</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10 p-4">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our Frontend Development Services?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our frontend development services focus on delivering seamless user
            experiences and high-performance web applications.
          </p>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\webAppDev\frontend2.avif"
                alt="Frontend Development Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon1.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Customizable designs to match your branding
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon2.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Focused on speed and performance optimization
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon3.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Advanced JavaScript integration for interactive elements
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon4.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Cross-device compatibility for smooth experience
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon5.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Responsive design for all screen sizes
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon6.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    SEO-friendly markup to boost your website’s visibility
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProcessFollow />

        <AyanshtechAdvantage />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default FrontendDev;
